module.exports = __webpack_public_path__ + "static/media/21_.8b6752e4.png";